var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 16",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62273 15.25C9.97393 15.25 12.1213 14.18 13.544 12.4266C13.7544 12.1672 13.5249 11.7883 13.1997 11.8503C9.50138 12.5548 6.10513 9.71836 6.10513 5.98396C6.10513 3.83281 7.25634 1.85469 9.12736 0.789604C9.41577 0.625429 9.34324 0.188034 9.01552 0.12748C8.5561 0.0427397 8.0899 6.95882e-05 7.62273 0C3.41507 0 0 3.41073 0 7.625C0 11.8339 3.40971 15.25 7.62273 15.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.1fc2f84c7243160a2b56046a663f98f2.svg";
export { ForwardRef as ReactComponent };